import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import MuzaffarPurImage from '../assets/ContactUs/MuzaffarPurCard.jpg';
import SitamarhiImage from '../assets/ContactUs/SitamarhiCard.jpg';

const ContactUs = () => {
    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-gray-50 font-sans">
            {/* Header Section */}
            <div className="bg-indigo-900 text-white text-center py-16 px-4">
                <h1 className="text-4xl md:text-5xl font-bold mb-4">Contact Us</h1>
                <p className="text-lg md:text-xl text-indigo-100 max-w-2xl mx-auto">
                    We are here to help your child grow and learn. Reach out to us at our branches or book an appointment online.
                </p>
            </div>

            <div className="max-w-7xl mx-auto px-4 py-12 space-y-20">
                {/* Muzaffarpur Section - Image Left, Details Right */}
                <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16 bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all hover:scale-[1.01] duration-300">
                    <div className="w-full md:w-1/2 h-[400px] md:h-[500px]">
                        <img
                            src={MuzaffarPurImage}
                            alt="Muzaffarpur Branch"
                            className="w-full h-full object-contain"
                        />
                    </div>
                    <div className="w-full md:w-1/2 p-8 md:p-12">

                        <h2 className="text-3xl font-bold text-gray-900 mb-6">Muzaffarpur Branch</h2>
                        <div className="space-y-4 text-gray-600 text-lg">
    
    <div className="flex items-start">
        <span className="w-8 shrink-0 text-indigo-600">
            <MapPin size={24} />
        </span>

        <div className="flex flex-col">
            <p>
                Add.1- Mehta Compound, Near Simna International Hotel, Power House Chowk, Muzaffarpur (842003), Bihar
            </p>
            <p>
                Add.2- New Sikanderpur Road, Near Gupta Timber, Akharaghat, Muzaffarpur (842001), Bihar
            </p>
        </div>
    </div>

    <div className="flex items-center">
        <span className="w-8 shrink-0 text-indigo-600">
            <Phone size={24} />
        </span>
        <span>7727043497, 8797681753</span>
    </div>

    <div className="flex items-center">
        <span className="w-8 shrink-0 text-indigo-600">
            <Mail size={24} />
        </span>
        <span>kidsworkrehabcentre@gmail.com</span>
    </div>

</div>
                    </div>
                </div>

                {/* Sitamarhi Section - Details Left, Image Right */}
                <div className="flex flex-col-reverse md:flex-row items-center gap-8 md:gap-16 bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all hover:scale-[1.01] duration-300">
                    <div className="w-full md:w-1/2 p-8 md:p-12">

                        <h2 className="text-3xl font-bold text-gray-900 mb-6">Sitamarhi Branch</h2>
                        <div className="space-y-4 text-gray-600 text-lg">
                            <p className="flex items-start">
                                <span className="w-8 shrink-0 text-indigo-600"><MapPin size={24} /></span>
                                <span>Shanti Nagar, Near ITI College, RCM Gali, Dumra, Sitamarhi (843301), Bihar</span>
                            </p>
                            <p className="flex items-center">
                                <span className="w-8 shrink-0 text-indigo-600"><Phone size={24} /></span>
                                <span>7727043497, 8797681753</span>
                            </p>
                            <p className="flex items-center">
                                <span className="w-8 shrink-0 text-indigo-600"><Mail size={24} /></span>
                                <span>kidsworkrehabcentre@gmail.com</span>
                            </p>
                        </div>
                    </div>
                    <div className="w-full md:w-1/2 h-[400px] md:h-[500px]">
                        <img
                            src={SitamarhiImage}
                            alt="Sitamarhi Branch"
                            className="w-full h-full object-contain"
                        />
                    </div>
                </div>

                {/* Book Online CTA */}
                <div className="text-center py-12">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6">Ready to get started?</h3>
                    <Link
                        to="/book-online"
                        className="inline-block bg-gradient-to-r from-indigo-600 to-violet-600 text-white text-lg font-semibold px-10 py-4 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                    >
                        Book Online Now
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
